import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FormattedMessage } from "react-intl";

export default function CustomDialog({
  isOpen,
  handleAccept,
  handleClose,
  title,
  content,
  maxWidth,
  hideConfirmation = false,
  displayClose = false,
  height = '75vh'
}) {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={maxWidth}
      fullWidth={true}
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent sx={{ height }}>
        {content}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={handleClose}>
          {displayClose ? <FormattedMessage id="CustomDialog.close" /> : <FormattedMessage id="CustomDialog.no" />}
        </Button>
        {!hideConfirmation && (
          <Button
            variant="contained"
            color="success"
            onClick={handleAccept}
            autoFocus
          >
            <FormattedMessage id="CustomDialog.yes" />
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
